import MailIcon from "@redotech/redo-icons/mail-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Footer } from "./footer";
import { GiftReceiptLogin } from "./gift-receipt-login";
import * as googleStyles from "./google-sign-in-button.module.css";
import { Header } from "./header";
import { SingleOrderLogin } from "./single-order-login";
import { SocialLoginOptionsSection } from "./social-login-options-section";
import { useLandingPage } from "./use-landing-page";

type LandingPageProps = {
  giftButtonClicked?: () => void;
  emailButtonClicked?: () => void;
  registerButtonClicked?: () => void;
  title?: string;
  showFooter?: boolean;
  showLogo?: boolean;
  nextUrl?: string;
  onBack?: () => void;
};

export function LandingPage({
  giftButtonClicked,
  emailButtonClicked,
  registerButtonClicked,
  onBack: onBackProp,
  showFooter,
  nextUrl,
  showLogo,
}: LandingPageProps) {
  const {
    texts,
    logo,
    hideGiftOption,
    registrationEnabled,
    socialLoginOptions,
    onBack,
    isGiftReceiptLogin,
  } = useLandingPage({ onBack: onBackProp });

  if (isGiftReceiptLogin) {
    return (
      <GiftReceiptLogin
        onBack={onBack}
        showFooter={showFooter}
        showLogo={showLogo}
      />
    );
  }

  const loginOptionsUI = (
    <Flex align="center" flexDirection="column" gap="md" justify="flex-start">
      {!hideGiftOption && giftButtonClicked && (
        <RedoButton
          hierarchy="link_underline"
          onClick={giftButtonClicked}
          text={texts.giftButton}
        />
      )}
      {registrationEnabled && registerButtonClicked && (
        <RedoButton
          hierarchy="link_underline"
          onClick={registerButtonClicked}
          text={texts.registerButton}
        />
      )}
    </Flex>
  );

  return (
    <Flex align="stretch" flexDirection="column" gap="3xl">
      <Header
        leftAlign={!showLogo}
        logo={showLogo ? logo : undefined}
        merchantName={texts.merchantName}
        onBack={onBack}
        subtitle={texts.subtitle}
        title={texts.title}
      />
      <SingleOrderLogin />

      <Flex flexDirection="column">
        {socialLoginOptions && socialLoginOptions.length > 0 && (
          <SocialLoginOptionsSection
            nextUrl={nextUrl}
            socialLoginOptions={socialLoginOptions}
          />
        )}
        <EmailButton
          emailButtonClicked={emailButtonClicked}
          text={texts.emailButton}
        />
      </Flex>
      {loginOptionsUI}
      {showFooter && <Footer centered />}
    </Flex>
  );
}

// I hate custom css but my hand is forced, I must use the same styles as the Google button so I get the same custom css styles as it from merchants :(
// This works because it gives it the same class name.
const EmailButton = ({
  text,
  emailButtonClicked,
}: {
  text: string;
  emailButtonClicked?: () => void;
}) => (
  <button className={googleStyles.googleButton} onClick={emailButtonClicked}>
    <Flex mr="md">
      <MailIcon />
    </Flex>
    <span className={googleStyles.googleButtonText}>{text}</span>
  </button>
);
